/**
 * Clear Filter Icon Enhancement
 * 增强 easysearch 清除筛选按钮 - 使用 refresh 图标
 */

(function() {
  'use strict';

  // Refresh 图标 SVG
  const refreshIconSVG = '<svg class="clear-filter-icon" xmlns="http://www.w3.org/2000/svg" fill="none" width="24" height="24" viewBox="0 0 24 24"><path d="M12,4C9.409500099999999,4,7.10606,5.230529799999999,5.6427398,7.1427398L8,9.5L2,9.5L2,3.5L4.2186298,5.7186298C6.0506101,3.4519998999999997,8.8555803,2,12,2C17.5228,2,22,6.47715,22,12L20,12C20,7.5817199,16.418301,4,12,4ZM4,12C4,16.418301,7.5817199,20,12,20C14.5905,20,16.893999,18.769501,18.3573,16.857300000000002L16,14.5L22,14.5L22,20.5L19.781401,18.281401C17.9494,20.548,15.1444,22,12,22C6.47715,22,2,17.5228,2,12L4,12Z" fill="currentColor"/></svg>';

  var initAttempts = 0;
  var maxAttempts = 20; // 最多尝试 20 次，每次间隔 500ms = 10秒

  function init() {
    var clearBtn = document.querySelector('.easysearch-btn-clean');
    
    if (!clearBtn) {
      initAttempts++;
      if (initAttempts < maxAttempts) {
        setTimeout(init, 500);
      }
      return;
    }

    // 检查是否已经添加过图标
    if (clearBtn.querySelector('.clear-filter-icon')) {
      return;
    }

    // 保存原有的 onclick 函数引用
    var originalOnclick = clearBtn.getAttribute('onclick');

    // 清空按钮内容并插入图标
    clearBtn.innerHTML = refreshIconSVG;

    // 添加 tooltip 提示
    clearBtn.setAttribute('title', 'Clear filters');
    clearBtn.setAttribute('aria-label', 'Clear all filters');

    // 移除原有的 onclick 属性
    clearBtn.removeAttribute('onclick');
    
    // 添加点击事件
    clearBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // 添加旋转动画
      this.classList.add('is-clearing');
      
      // 调用原有的清除方法
      if (typeof easysearch !== 'undefined' && typeof easysearch.clearTagFilter === 'function') {
        easysearch.clearTagFilter();
      }
      
      // 移除动画类
      var btn = this;
      setTimeout(function() {
        btn.classList.remove('is-clearing');
      }, 500);
    });

    console.log('[Clear Filter Icon] Initialized successfully');
  }

  // 多种方式确保初始化
  // 1. DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 2. window.onload 作为备用
  window.addEventListener('load', function() {
    setTimeout(init, 1000);
  });

  // 3. MutationObserver 监听动态加载
  var observer = new MutationObserver(function(mutations) {
    var clearBtn = document.querySelector('.easysearch-btn-clean');
    if (clearBtn && !clearBtn.querySelector('.clear-filter-icon')) {
      init();
    }
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
})();
